import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import {
  Form,
  Input,
  RequiredHelpPhrase,
  Row,
  SonForm,
  SubmitButton,
  TextParam,
  UrlParam,
  useForm,
} from '../../../_lib/Form2';
import { useRefreshView } from '../../../_lib/ViewFetcher';
import { useDelayed } from '../../../hooks/useDelayed';

export type AddExternalFavoriteFormProps = {
  form: SonForm<TextParam<'title'> | UrlParam<'link'>>;
  closeModal: () => void;
};

export function AddExternalFavoriteForm({ form, closeModal }: AddExternalFavoriteFormProps) {
  const { refreshView } = useRefreshView();
  const { t } = useSonTranslation('FavoritedPages');
  const delayedCloseModal = useDelayed(closeModal);

  const onSuccess = () => {
    delayedCloseModal();
    refreshView();
  };

  const { formProps, params, fetchState } = useForm({ form, onSuccess });
  const link = params.findByName('link');

  return (
    <Form id="add-external-favorite-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('addForm.input.title')} param={params.getByName('title')} />
      </Row>
      {link ? (
        <Row>
          <Input label={t('addForm.input.link')} param={link} helpText={t('addForm.input.helpText')} />
        </Row>
      ) : null}
      <SubmitButton
        buttonLabel={t('addForm.save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}
